import type { LobbyFilterType } from '../../../components/organisms/LobbyFilter'
import { ECurrency, EGameType } from '../../../types/enums'
import type { PageEntityType } from '../types'

export const defaultPage = {
  page: 'main',
  options: {
    tab: ECurrency.COIN,
    gameType: EGameType.NLH,
    limits: [],
    sitNow: false,
  } satisfies LobbyFilterType,
} satisfies PageEntityType
